import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import OrbitEllipse from "../component/OrbitEllipse";
import TestimonialCard from "../component/TestimonialCard";
import { TfiArrowCircleRight, TfiArrowCircleLeft } from "react-icons/tfi";
import { IoChevronForwardSharp, IoChevronBackSharp } from "react-icons/io5";

const AboutUs = () => {
  const testimonials = [
    {
      id: 1,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Madhan Sr",
      text: `I had a wonderful stay at this hotel — the rooms were clean, comfortable, and well-maintained.
The staff were polite, helpful, and always smiling, making me feel truly welcome.
The food was delicious with plenty of variety, and the service was quick and professional.
The location was convenient and peaceful, perfect for both relaxation and travel.
Overall, an excellent experience — I'd highly recommend this hotel and would love to stay again.`,
      icon: "M",
    },
    {
      id: 2,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Lachu",
      text: `My stay was truly wonderful! The staff were incredibly professional, and the services, food, and cleanliness were all top-notch.
One side of the accommodation was beautifully surrounded by nature, adding to the overall experience.
We thoroughly enjoyed our stay and had a very good experience overall.`,
      icon: "L",
    },
    {
      id: 3,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Krishna Khandige",
      text: `We stay at this hotel as we come in from Bangalore on work and the hotel is great. The rooms are sparkling clean and service is great too. We met owner and Managing Director of the hotel who is always hands on at the hotel and an extremely humble person. I would highly recommend anyone travelling past Ranipet to make a stop here. Huge plus point is their 24hr check in policy so you don't have to worry about missing your check in time.`,
      icon: "K",
    },
    {
      id: 4,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Vishnu Vardhan Shekar",
      text: `I had a wonderful experience at this hotel! Right from the moment I arrived, the staff made me feel welcome and taken care of. The rooms were clean, comfortable, and thoughtfully designed — perfect for relaxing after a long day.
What really stood out was the attention to detail and the personal touches that made the stay feel special. Whether it was the friendly service, the peaceful ambiance, or just how everything was run smoothly, you could tell the team really cares about the guest experience.
If you're looking for a place that feels more like a warm retreat than just a hotel stay, I highly recommend this one. Will definitely be back!`,
      icon: "V",
    },
    {
      id: 5,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Vaibhav Shukla",
      text: `Thank you to the HOTEL SASTHAGRAND for providing such a wonderful experience. The combination of the upgraded room, the beautiful confluence of modern and traditional ambience, and the exceptional service made my stay truly remarkable. I will certainly recommend your hotel and look forward to staying with you again in the future.`,
      icon: "V",
    },
    {
      id: 6,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Jagan Jay",
      text: `stayed 4 nights here… neet and clean rooms are big and confortable …. Food are good …. Staff are polite and helpful…. Highly recommended in arcot`,
      icon: "J",
    },
  ];

  const orbitAvatars = [
    "/assets/ava-2.png",
    "/assets/ava-3.png",
    "/assets/ava-4.png",
    "/assets/ava-5.png",
    "/assets/ava-6.png",
    "/assets/ava-7.png",
  ];

  const brandIcon = [
    {
      id: 1,
      img: "/assets/gobilo.svg",
      a: "https://www.goibibo.com/hotels/address-of-sastha-grand-hotel-in-ranipettai-6046589066353381674/",
    },
    {
      id: 2,
      img: "/assets/makeMyTrip.svg",
      a: "https://www.makemytrip.com/hotels/hotel_sastha_grand-details-ranipet.html",
    },
    {
      id: 3,
      img: "/assets/adogo.svg",
      a: "https://www.agoda.com/en-in/hotel-sastha-grand-h65514585/hotel/ranipet-in.html?cid=-310&ds=foVA03WbnfTc8Xpp",
    },
    {
      id: 4,
      img: "/assets/booking-icon.svg",
      a: "https://www.booking.com/searchresults.en-gb.html?aid=357029&label=yho748jc-10CAsobEIMc2FzdGhhLWdyYW5kSDNYA2hsiAEBmAEzuAEXyAEM2AED6AEB-AEBiAIBqAIBuAKp4c3OBsACAdICJDhlN2ZmNjVhLTFiNGQtNGVmZC1hNWJiLTBmODIwODgxMzM5ZNgCAeACAQ&highlighted_hotels=13497319&redirected=1&city=-2089072&hlrd=user_sh&group_adults=2&source=hotel&expand_sb=1&keep_landing=1&sid=120bd4a31702b72d3fce8eb7b0c6fbe8",
    },
  ];

  const sasthaGrand = [
    {
      id: 1,
      icon: "/assets/flexibility.svg",
      title: "No hidden fees",
      content: "Transparent pricing with no hidden fees.",
    },
    {
      id: 2,
      icon: "/assets/booke-1.svg",
      title: "Instant booking",
      content: "Get confirmation right after you reserve.",
    },
    {
      id: 3,
      icon: "/assets/flexible.svg",
      title: "Flexibility",
      content: "Flexible options with free cancellation on many listings.",
    },
  ];

  const [active, setActive] = useState(0);

  useEffect(() => {
    const total = orbitAvatars.length;
    const rotationDuration = 40000;
    const stepTime = rotationDuration / total;
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, stepTime);
    return () => clearInterval(interval);
  }, []);

  const [perView, setPerView] = useState(3);
  const [index, setIndex] = useState(0);

  // ── Testimonial modal state ──
  const [expandedId, setExpandedId] = useState(null);
  const expandedTes = testimonials.find((t) => t.id === expandedId) || null;

  // Cursor-follow button
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [buttonPos, setButtonPos] = useState({ x: 0, y: 0 });
  const requestRef = useRef();

  const animate = () => {
    setButtonPos((prev) => ({
      x: prev.x + (cursorPos.x - prev.x) * 0.15,
      y: prev.y + (cursorPos.y - prev.y) * 0.15,
    }));
    requestRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [cursorPos]);

  // Lock body scroll when modal open
  useEffect(() => {
    document.body.style.overflow = expandedId ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [expandedId]);

  // Close on ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setExpandedId(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w < 640) setPerView(1);
      else if (w < 1024) setPerView(2);
      else setPerView(3);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const maxIndex = useMemo(
    () => Math.max(0, testimonials.length - perView),
    [testimonials.length, perView],
  );

  const atStart = index === 0;
  const atEnd = index === maxIndex;
  const nextSlide = () => setIndex((prev) => Math.min(prev + 1, maxIndex));
  const prevSlide = () => setIndex((prev) => Math.max(prev - 1, 0));
  const translate = `-${index * (100 / perView)}%`;

  // ── Video / Guest Feedback ──
  const feedBack = [
    { id: 1, icon: "/assets/feed-1.png", video: "/assets/sastha-video-1.mp4" },
    { id: 2, icon: "/assets/feed-2.png", video: "/assets/sastha-video-2.mp4" },
    { id: 3, icon: "/assets/feed-3.png", video: "/assets/sastha-video-3.mp4" },
    { id: 4, icon: "/assets/feed-3.png", video: "/assets/sastha-video-4.mp4" },
    { id: 5, icon: "/assets/feed-3.png", video: "/assets/sastha-video-5.mp4" },
    { id: 6, icon: "/assets/feed-3.png", video: "/assets/sastha-video-6.mp4" },
  ];
  const [itemsPerPage, setItemsPerPage] = useState(3);

  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = Math.ceil(feedBack.length / itemsPerPage);

  const [currentIndex, setCurrentIndex] = useState(0);

  const videoRef = useRef(null);

  const videoRefs = useRef({});
  const [playingIds, setPlayingIds] = useState({});

  const totalVideos = feedBack.length;

  /*   const handleNext = () => {
  setCurrentIndex((prev) =>
    Math.min(prev + 1, testimonials.length - perView)
  );
};

const handleBack = () => {
  setCurrentIndex((prev) => Math.max(prev - 1, 0));
}; */

  useEffect(() => {
    if (videoRef.current) {
      try {
        videoRef.current.currentTime = 0;
        const p = videoRef.current.play();
        if (p && typeof p.catch === "function") p.catch(() => {});
      } catch (e) {}
    }
  }, [currentPage]);

  const handleNext = () => {
    setCurrentIndex((prev) =>
      Math.min(prev + 1, testimonials.length - perView),
    );
  };

  const handleBack = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  const pauseAll = () => {
    Object.values(videoRefs.current).forEach((el) => {
      if (el && !el.paused) el.pause();
    });
    setPlayingIds({});
  };

  const togglePlay = (id) => {
    const video = videoRefs.current[id];
    if (!video) return;

    if (video.paused) {
      // Pause all others
      Object.entries(videoRefs.current).forEach(([vid, el]) => {
        if (String(vid) !== String(id) && el && !el.paused) {
          el.pause();
          setPlayingIds((prev) => ({ ...prev, [vid]: false }));
        }
      });
      video.play();
      setPlayingIds((prev) => ({ ...prev, [id]: true }));
    } else {
      video.pause();
      setPlayingIds((prev) => ({ ...prev, [id]: false }));
    }
  };

  useEffect(() => {
    const updateItems = () => {
      if (window.innerWidth < 640) {
        setItemsPerPage(1);
      } else if (window.innerWidth < 1024) {
        setItemsPerPage(2);
      } else {
        setItemsPerPage(3);
      }
    };
    updateItems();
    window.addEventListener("resize", updateItems);
    return () => window.removeEventListener("resize", updateItems);
  }, []);

  // ALSO reset index when itemsPerPage changes so it doesn't go out of bounds
  useEffect(() => {
    setCurrentIndex(0);
  }, [itemsPerPage]);

  return (
    <section className="w-full bg-[#FFFEF2] px-4 md:px-28 py-14">
      {/* ── Why Sastha Grand ── */}
      <div className="flex justify-center items-center mt-10">
        <h2 className="text-primary font-calson text-[30px] md:text-[64px] font-medium">
          Why Sastha Grand
        </h2>
      </div>

      <div className="w-full mt-10">
        <div className="relative flex flex-col justify-between md:flex-row md:gap-0 gap-10">
          {sasthaGrand.map((sas, i) => (
            <div key={i} className="relative text-center z-10">
              {i !== sasthaGrand.length - 1 && (
                <div className="hidden md:block absolute w-[130px] h-[50px] md:w-[300px] md:h-[83px] left-60 top-10">
                  <img src="/assets/vecotr-1.svg" />
                </div>
              )}
              <div className="mx-auto w-16 h-16 md:w-[100px] md:h-[100px] bg-[#D9E3EC] rounded-3xl flex items-center justify-center sm:mb-8">
                <img
                  src={sas.icon}
                  alt=""
                  className="w-[30px] h-[30px] md:w-[46px] md:h-[46px]"
                />
              </div>
              <h4 className="text-[14px] md:text-[20px] font-creto font-medium mb-2">
                {sas.title}
              </h4>
              <div className="md:w-[264px] md:h-[48px]">
                <p className="text-[12px] md:text-[16px] text-gray-600 font-creto font-normal leading-relaxed px-2 sm:px-0">
                  {sas.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Testimonials ── */}
      <section className="w-full rounded-md md:py-14 mt-10 relative">
        <h2 className="text-center font-calson font-medium text-[40px] sm:text-[56px] md:text-[64px] text-primary">
          Testimonial
        </h2>

        <div className="mx-auto px-4 sm:px-6 md:py-10 sm:py-12  relative">
          <div className="hidden md:block">
            <button
              onClick={prevSlide}
              disabled={atStart}
              className={`absolute left-2 lg:-left-10 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full grid place-items-center transition
                ${atStart ? "text-primary opacity-40 cursor-not-allowed" : "text-primary hover:text-white hover:bg-primary"}`}
            >
              <TfiArrowCircleLeft className="text-[28px]" />
            </button>
            <button
              onClick={nextSlide}
              disabled={atEnd}
              className={`absolute right-2 lg:-right-10 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full grid place-items-center text-primary hover:text-white transition
                ${atEnd ? "opacity-40 cursor-not-allowed" : "hover:bg-primary"}`}
            >
              <TfiArrowCircleRight className="text-[28px]" />
            </button>
          </div>

          {/* Slider */}
          {/* overflow-x-hidden clips slider horizontally, py-3 lets shadow breathe vertically */}
          <div className="overflow-hidden py-3">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(${translate})` }}
            >
              {testimonials.map((tes) => {
                const isDimmed = expandedId && expandedId !== tes.id;

                return (
                  <div
                    key={tes.id}
                    className={`shrink-0 px-2 sm:px-3 transition ${
                      isDimmed
                        ? "opacity-30 pointer-events-none"
                        : "opacity-100"
                    }`}
                    style={{ width: `${100 / perView}%` }}
                  >
                    <div
                      onMouseMove={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        setCursorPos({
                          x: e.clientX - rect.left,
                          y: e.clientY - rect.top,
                        });
                      }}
                      className="
              group relative border-[#D4C194] border-[1px] rounded-3xl bg-[#F8F4ED]
              p-4 sm:p-5 w-full h-[260px]
              transition-all duration-300 ease-in-out
              hover:shadow-[0_0_20px_rgba(0,0,0,0.15)]
            "
                    >
                      {/* Card top */}
                      <div className="flex justify-between items-start">
                        <div className="flex gap-3 items-center">
                          <span className="w-10 h-10 bg-primary text-white rounded-full flex items-center justify-center text-[18px] -mt-2">
                            {tes.icon}
                          </span>
                          <div>
                            <h2 className="font-creto font-medium text-primary text-[16px] sm:text-[18px] leading-5">
                              {tes.name}
                            </h2>
                            <img
                              src={tes.star}
                              className="mt-1 w-20 sm:w-auto"
                              alt=""
                            />
                          </div>
                        </div>
                        <img
                          src={tes.image}
                          className="w-5 h-5 sm:w-6 sm:h-6"
                          alt=""
                        />
                      </div>

                      <p className="mt-4 text-[#45443F] text-[14px] font-normal font-micro line-clamp-6">
                        {tes.text}
                      </p>

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setExpandedId(tes.id);
                        }}
                        style={{
                          left: buttonPos.x - 40,
                          top: buttonPos.y - 40,
                        }}
                        className="
                absolute w-[80px] h-[80px] rounded-full
                border border-primary bg-white/90
                text-primary text-[13px]
                flex items-center justify-center
                opacity-0 group-hover:opacity-100
                pointer-events-auto
              "
                      >
                        View more
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="flex md:hidden justify-center  mt-5 md:mt-8">
            <button
              onClick={prevSlide}
              disabled={atStart}
              className={` w-11 h-11 rounded-full grid place-items-center transition
                ${atStart ? "opacity-40 cursor-not-allowed" : "hover:bg-primary hover:text-white"}`}
            >
              <TfiArrowCircleLeft className="text-2xl" />
            </button>
            <button
              onClick={nextSlide}
              disabled={atEnd}
              className={` w-11 h-11 rounded-full grid place-items-center transition
                ${atEnd ? "opacity-40 cursor-not-allowed" : "hover:bg-primary hover:text-white"}`}
            >
              <TfiArrowCircleRight className="text-2xl" />
            </button>
          </div>
        </div>
      </section>

      {/* ── Testimonial Modal Portal ── */}
      {expandedId &&
        expandedTes &&
        createPortal(
          <div
            className="fixed inset-0 z-[9999]  flex items-center justify-center p-4 sm:p-8"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={() => setExpandedId(null)}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="relative border-[#D4C194] border-[1px] rounded-3xl bg-[#F8F4ED]
                p-5 sm:p-8 w-full max-w-lg max-h-[80vh] overflow-y-auto shadow-2xl
                animate-fadeIn"
            >
              {/* Close button */}
              {/*  <button
                onClick={() => setExpandedId(null)}
                className="absolute top-4 right-4 w-8 h-8 rounded-full border border-primary
                  bg-white text-primary text-[14px] flex items-center justify-center
                  hover:bg-primary hover:text-white transition"
              >
                ✕
              </button> */}

              {/* Modal header */}
              <div className="flex items-start justify-between w-full">
                {/* LEFT SIDE */}
                <div className="flex gap-3 items-center">
                  <span className="w-10 h-10 bg-primary text-white rounded-full flex items-center justify-center text-[18px] -mt-2">
                    {expandedTes.icon}
                  </span>

                  <div>
                    <h2 className="font-creto font-medium text-primary text-[16px] sm:text-[18px] leading-5">
                      {expandedTes.name}
                    </h2>

                    <img
                      src={expandedTes.star}
                      className="mt-1 w-20 sm:w-auto"
                      alt=""
                    />
                  </div>
                </div>

                {/* RIGHT SIDE */}
                <img
                  src={expandedTes.image}
                  className="w-5 h-5 sm:w-6 sm:h-6 shrink-0"
                  alt=""
                />
              </div>
              {/* Full review text */}
              <p className="mt-5 text-[#45443F] text-[14px] font-normal font-micro leading-relaxed whitespace-pre-line">
                {expandedTes.text}
              </p>
            </div>
          </div>,
          document.body,
        )}

      {/* ── Guest Feedback ── */}
      <div className="w-full md:px-6 md:py-12">
        <h2 className="text-center font-calson font-medium text-[40px] sm:text-[56px] md:text-[64px] text-primary">
          Guest Feedback
        </h2>

        <div className="relative w-full overflow-hidden">
          {/* Slider - moves one video at a time */}
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{
              transform: `translateX(-${currentIndex * (100 / itemsPerPage)}%)`,
            }}
          >
            {feedBack.map((item) => (
              <div
                key={item.id}
                className="shrink-0 px-3 mt-5 md:mt-10"
                style={{ width: `${100 / itemsPerPage}%` }}
              >
                {/* Card */}
                <div className="relative h-[550px] w-full bg-black rounded-3xl overflow-hidden  group">
                  {/* Video with native controls (sound/speaker included) */}
                  <video
                    ref={(el) => (videoRefs.current[item.id] = el)}
                    src={item.video}
                    className="w-full h-full object-cover"
                    playsInline
                    onPlay={() =>
                      setPlayingIds((prev) => ({ ...prev, [item.id]: true }))
                    }
                    onPause={() =>
                      setPlayingIds((prev) => ({ ...prev, [item.id]: false }))
                    }
                  />

                  {/* Centered Play/Pause Overlay Button */}
                  <div
                    onClick={() => togglePlay(item.id)}
                    className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 cursor-pointer ${
                      playingIds[item.id]
                        ? "opacity-0 group-hover:opacity-100"
                        : "opacity-100"
                    }`}
                    // Don't cover the native controls at the bottom
                    style={{ bottom: "48px", top: 0, position: "absolute" }}
                  >
                    <div className="w-16 h-16 rounded-full bg-black/50 flex items-center justify-center backdrop-blur-sm border border-white/30">
                      {playingIds[item.id] ? (
                        // Pause Icon
                        <svg
                          className="w-7 h-7 text-white"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                        </svg>
                      ) : (
                        // Play Icon
                        <svg
                          className="w-7 h-7 text-white ml-1"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      )}
                    </div>
                  </div>

                  {/* Native controls shown at bottom for sound */}
                  <div className="absolute bottom-0 left-0 right-0">
                    <video
                      src={item.video}
                      className="w-full opacity-0 h-[48px] pointer-events-none"
                    />
                    <div
                      className="absolute bottom-0 left-0 right-0 h-[48px]"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-center mt-5 gap-2 items-center md:gap-4 md:mt-8">
            <button
              onClick={handleBack}
              disabled={currentIndex === 0}
              className="w-10 h-10 rounded-full border border-[#C9A86A] text-[#C9A86A] flex items-center justify-center hover:bg-[#C9A86A] hover:text-white transition disabled:opacity-40 disabled:cursor-not-allowed"
            >
              <IoChevronBackSharp fontSize={20} />
            </button>
            <button
              onClick={handleNext}
              disabled={currentIndex >= totalVideos - itemsPerPage}
              className="w-10 h-10 rounded-full border border-[#C9A86A] text-[#C9A86A] flex items-center justify-center hover:bg-[#C9A86A] hover:text-white transition disabled:opacity-40 disabled:cursor-not-allowed"
            >
              <IoChevronForwardSharp fontSize={20} />
            </button>
          </div>
        </div>
      </div>

      {/* ── Available On ── */}
      <div className="mt-10">
        <h1 className="font-calson font-medium text-[30px] md:text-[64px] text-primary flex justify-center items-center">
          We are also Available in
        </h1>
        <div className="flex flex-wrap justify-center mt-10 ">
          {brandIcon.map((bra, i) => {
            const isLast = i === brandIcon.length - 1;
            return (
              <a key={bra.id} href={bra.a} target="_blank" rel="noreferrer">
                <div
                  className={`flex items-center justify-center px-4 sm:px-6 w-[140px] md:w-[180px] h-[44px] sm:h-[54px]
          ${!isLast ? "md:border-r-2 md:border-[#929091]" : ""}`}
                >
                  <img
                    src={bra.img}
                    alt="brand"
                    className="w-full h-auto object-contain"
                  />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
